import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./providers/auth-context";
import { useActiveIntegrations } from "../scenes/dashboard/active-integrations-provider";
import DemoBar from "./demo-bar";

const DemoBarPersonal = () => {
    const { isLoading, isDemo, userHasEnterpriseSubscription, isUserPayingCustomer } = useAuth();

    const { activeIntegrations } = useActiveIntegrations();

    if (isLoading || isDemo || !isUserPayingCustomer) return null;

    const anyActiveIntegration =
        !activeIntegrations ||
        !activeIntegrations.data ||
        activeIntegrations.data.integrations.find((int) => int.connected);

    if (anyActiveIntegration || userHasEnterpriseSubscription) return null;

    const getUpgradeTo = () => {
        if (!anyActiveIntegration)
            return (
                <>
                    <Link to="/setup-wizard" style={{ color: "#7c1374" }}>
                        Get started here
                    </Link>
                    .
                </>
            );
        return null;
    };

    return (
        <DemoBar>
            You are currently on <strong>Demo Mode</strong>. {getUpgradeTo()}
        </DemoBar>
    );
};

export default DemoBarPersonal;
